import type { DatapointOptionsForPerformanceDatapoint } from 'owa-analytics-types';
import type { AnalyticsCoreEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';
import { PerformanceDatapoint } from './PerformanceDatapoint';

export class PerformanceCoreDatapoint extends PerformanceDatapoint {
    constructor(
        eventName: AnalyticsCoreEventNames,
        mailbox: MailboxInfo | undefined,
        options?: DatapointOptionsForPerformanceDatapoint
    ) {
        super(eventName, mailbox, options);

        this.options = { ...this.options, isCore: true };
    }
}
